import { isDefinedArray, reduce } from "et3-type-guards";

import ET3Div from "../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import {
  SURFACE_BORDER,
  SURFACE_RADIUS_CSS,
  SURFACE_SHADOW
} from "../../../core/et3-theme/surface-constants";
import getApproveRejectStore from "../../../stores/approval-reject-store";
import {
  APPROVAL_PAGE_BOTTOM_PADDING,
  APPROVAL_PAGE_SECTION_GAP
} from "../approve-reject-constants";
import ApprovalEmptyState from "./ApprovalEmptyState";
import ApprovalPictureViewer from "./ApprovalPictureViewer";
import ApprovalQueueStrip from "./ApprovalQueueStrip";
import UserRow from "./user-row";

const ApproveRejectData = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitY } = theme;
  const store = getApproveRejectStore();
  const approvalData = store.approvalData.get();
  const isPoolLoaded = isDefinedArray(approvalData);
  const lastVisibleIndex = approvalData.length - 1;

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={true}
      withShadow={false}
      width={0}
      height={0}
      fDirection="column"
      alignItems="stretch"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{
        width: "100%",
        minWidth: 0,
        gap: APPROVAL_PAGE_SECTION_GAP * unitY,
        paddingBottom: APPROVAL_PAGE_BOTTOM_PADDING * unitY
      }}
      onClick={() => {}}
    >
      <ApprovalPictureViewer />
      {isPoolLoaded ? <ApprovalQueueStrip /> : null}
      {!isPoolLoaded ? (
        <ApprovalEmptyState
          titleKey={"APPROVAL_NOT_LOADED_TITLE"}
          bodyKey={"APPROVAL_NOT_LOADED_BODY"}
          isNotLoaded={true}
        />
      ) : null}

      {isPoolLoaded ? (
        <ET3Div
          isScrollable={false}
          isExtendable={true}
          withShadow={false}
          width={0}
          height={0}
          fDirection="column"
          alignItems="stretch"
          justifyContent="flex-start"
          color={colors.all.white}
          style={{
            boxSizing: "border-box",
            width: "100%",
            minWidth: 0,
            border: SURFACE_BORDER,
            borderRadius: SURFACE_RADIUS_CSS,
            boxShadow: SURFACE_SHADOW,
            overflow: "hidden"
          }}
          onClick={() => {}}
        >
          {approvalData.map((userEntry, index) => {
            return (
              <UserRow
                key={reduce(() => userEntry.user_id, index)}
                userEntry={userEntry}
                isLastRow={index === lastVisibleIndex}
              />
            );
          })}
        </ET3Div>
      ) : null}
    </ET3Div>
  );
});

export default ApproveRejectData;
